import Gardener from 'scoreboard/components/gardener'
import _ from 'lodash'
import { Transform } from 'stream'
import initiativesPasteAllowed from './edit/initiatives-paste-allowed'
import i18n from 'scoreboard/components/i18n'
import TopLevelNode from 'scoreboard/components/top-level-node'
import * as AddTypes from 'scoreboard/components/add-types'
const { CHILD, SIBLING, ROOT } = AddTypes
import unwrapModel from 'scoreboard/components/unwrap-model'

//note there is styling associated with the id='all-items' only because currently we can't add
//arbitrary classes to the tree nodes
const ALL_INITIATIVES = 'all-items'

/**
 * Based on the type of the initiative selected in the tree and the type of a
 * newly created initiative, determines whether the newly created initiative
 * should be positioned as a CHILD or SIBLING or ROOT.
 *
 * The rules are (from #7476):
 * 5) If the selected item is an initiative item of type initiative, it depends
 * on the type selected on the right. Initiative will be a sibling, task or
 * milestone will be a child.
 * 6) If the selected item is an initiative item of type task, it depends on the
 * type selected on the right. Task will be a sibling, Milestone will be a child.
 * 7) If the selected item is an initiative item of type milestone, the new item
 * is a sibling.
 *
 * The exception is if the relative initiative is replicated, in that case
 * the new initiative is be added as the root #19293
 *
 * @param relative
 *            the tree node attributes representing the relative item
 * @param newItem
 *            the model of the new item being added
 * @return CHILD or SIBLING or ROOT
 */
function getAddType(relative, newItem) {
	relative = unwrapModel(relative)
	newItem = unwrapModel(newItem)

	if (!_.isNil(_.get(relative, 'syncId'))) {
		return ROOT
	}

	if (relative.type === 'initiative') {
		return newItem.type === 'initiative' ? SIBLING : CHILD
	}
	if (relative.type === 'task') {
		return newItem.type === 'milestone' ? CHILD : SIBLING
	}
	if (relative.type === 'milestone') {
		return SIBLING
	}

	throw new Error('Unable to determine new position.  relative.type: ' + relative.type + ', newItem.type: ' + newItem.type)
}

var InitiativeGardener = Gardener.extend({

	getAddType: getAddType,

	_treeOptions: function() {
		var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)

		treeOptions.indicator = _.isUndefined(this.options.indicator) ? true : this.options.indicator
		treeOptions.droppable = initiativesPasteAllowed
		treeOptions.stream = treeOptions.stream.pipe(this._transform())

		if (this.options.allowAll) {
			treeOptions.stream = new TopLevelNode({
				id : ALL_INITIATIVES,
				icon: 'initiative',
				label: i18n.get('initiatives.allNodes')
			}).addToStream(treeOptions.stream)
		}

		return treeOptions
	},

	/**
	 * Returns a Transform that:
	 * 1) toggles the visible property of the nodes in the tree appropriately
	 * based on whether they are archived
	 * 2) removes initiative colors if they shouldn't be displayed
	 */
	_transform: function() {
		let self = this
		var transform = new Transform({ objectMode: true })
		transform._transform = function (node, enc, next) {
			node.visible = _.isNil(node.archiveDate)
			// #24906 we should only show initiative colors in the initiatives
			// nav pane
			node.color = self.options.showColors ? node.color : ''
			this.push(node)
			next()
		}
		return transform
	},

	/**
	 * @param model The initiative node
	 * @param [options.archiveAction] Defined if this edit is a result of (un)archive
	 */
	_editDomainObject: function(model, options={}) {
		if (!this.interested(model)) return

		Gardener.prototype._editDomainObject.apply(this, arguments)
		var node = _.clone(model.attributes)
		const visible = _.isNil(node.archiveDate)
		const cascade = !!options.archiveAction
		this._editVisibility(node.id, visible, cascade)
	},

	/**
	 * @param id The initiative node id
	 * @param visible If the tree node should be visible or not
	 * @param cascade If the children should inherit the visibility
	 */
	_editVisibility: function(id, visible, cascade) {
		var node = this.tree.get(id)
		node.visible = visible
		this.tree.edit(node)

		cascade && _.each(this.tree.children(id), child => {
			this._editVisibility(child.id, visible, cascade)
		})
	}

})

_.extend(InitiativeGardener, {
	getAddType,
	ALL_INITIATIVES
})
export default InitiativeGardener
export { getAddType }
export { ALL_INITIATIVES }

InitiativeGardener.__filename__ = 'initiatives/initiatives-gardener.js'
